import { render } from "./SezView.vue?vue&type=template&id=3ea7814a&scoped=true"
import script from "./SezView.vue?vue&type=script&lang=js"
export * from "./SezView.vue?vue&type=script&lang=js"

import "./SezView.vue?vue&type=style&index=0&id=3ea7814a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea7814a"]])

export default __exports__